export default __webpack_public_path__ + "static/media/topper_choice_star.a4e07665.svg";